import React, { memo } from 'react';

const InfoRowSection = memo(({ children }) => <div className="info-row-section">{children}</div>);

export default InfoRowSection;
